import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { Institution } from './Institution';

export interface PaymentOutRow {
  id: number;
  created_at: string;
  event_id: number;
  institution_id: number;
  stripe_connect_account_id: string | null;
  stripe_transfer_id: string;
  currency: string;
  amount: number;
  status: string;
}

export const PaymentOut: Entity<PaymentOutRow> = {
  id: 'PaymentOut',
  title: 'PaymentOut',
  service: 'main',
  rowLabel: (row: PaymentOutRow) => row.stripe_transfer_id,
  primaryKeyFields: ['id'],
  pluralTitle: 'Payments Out',
  allowAddRows: false,
  allowDeleteRows: false,
  source: {
    tableName: 'public.payment_out',
  },
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  defaultSort: [['created_at', 'DESC']],
  defaultFilters: [
    { fieldId: 'event_id', operator: 'eq', value: '' },
    { fieldId: 'institution_id', operator: 'eq', value: '' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
      listColumn: true,
    },
    created_at: {
      seq: 10,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    event_id: {
      seq: 20,
      type: FieldType.Reference,
      label: 'Event',
      refEntity: Event,
      listColumn: true,
    },
    institution_id: {
      seq: 30,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
      listColumn: true,
    },
    stripe_connect_account_id: {
      seq: 40,
      label: 'Stripe Connect Account',
      type: FieldType.Text,
    },
    stripe_transfer_id: {
      seq: 50,
      label: 'Stripe Transfer',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
    },
    currency: {
      seq: 60,
      label: 'Currency',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
    },
    amount: {
      seq: 70,
      label: 'Amount',
      type: FieldType.Decimal,
      decimalDigits: 2,
      staticPrefix: '£',
      mandatory: true,
      listColumn: true,
    },
    status: {
      seq: 80,
      label: 'Status',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
    },
  },
};
